import { Controller } from "@hotwired/stimulus";

// Keeps the "Check in N" button in step with the ticked tickets.
export default class extends Controller {
  static targets = ["checkbox", "submit"];

  count() {
    const checked = this.checkboxTargets.filter((box) => box.checked).length;
    this.submitTarget.textContent = `Check in ${checked}`;
    this.submitTarget.disabled = checked === 0;
  }
}
